module.exports = __webpack_public_path__ + "img/serverConnection.d8a78f11.png";